import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_MACHINE_SENSOR_URL } from '../../connection.data';

@Injectable()
export class MachineSensorService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_MACHINE_SENSOR_URL;
    }
}